import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import { useQuery, useQueryClient } from '@tanstack/react-query';
import API_URL from './api/config';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footerbar from './components/Footerbar';
import useAppLayout from './hooks/useAppLayout';

function SignUpGender() {

   const { isSidebarVisible, showSidebar, toggleSidebar } = useAppLayout();

    const navigate = useNavigate();
     
    const [gender, setGender] = useState("");
    const [isSaving, setIsSaving] = useState(false);
      
  const handleSaveGender = () => {
    if (!gender) {
      toast.error("Please select gender");
      return;
    }
  
    setIsSaving(true);
  
    axios.post(
      `${API_URL}/update-user-gender-api`,
      { gender },
      { withCredentials: true }
    )
      .then((res) => {
        //toast.success("Gender saved successfully");

        if (res.data.gender === "Male") {
          localStorage.setItem('user_id', res.data.user_id);
          localStorage.setItem('family_code', res.data.family_code);
          localStorage.setItem('family_admin', res.data.family_admin);
  
        navigate('/family-info-update');
        }
        // Use response gender OR local state
        if (res.data.gender === "Female") {
          localStorage.setItem('user_id', res.data.user_id);
          localStorage.setItem('family_code', res.data.family_code);
          localStorage.setItem('family_admin', res.data.family_admin);
  
          navigate('/sign-up-category');
        }
      })
      .catch(() => {
        toast.error("Failed to save gender");
      })
      .finally(() => setIsSaving(false));
  };

      
    return (
    

        <div className="scrollPageContainer theme-light">
                    <div className="main-wrapper">
                        {isSidebarVisible && <Sidebar />}
                        <Header toggleSidebar={toggleSidebar} />
                        <Sidebar show={showSidebar} toggle={toggleSidebar} />
                        <Footerbar toggleSidebar={toggleSidebar} />
        
                         <ToastContainer />
        
    
        <div className="page-wrapper pb-0 d-flex justify-content-center">
        <div className="content container-fluid">
           

          <div className="row justify-content-center">
            <div className="col-12 col-lg-8 col-xl-7">
              {/* ✅ remove overflow-hidden (it can clip dropdowns) */}
              <div className="card shadow-sm border-0 rounded-4">
                {/* ✅ smaller header */}
                <div
                  className="px-3 py-3"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(116,186,84,0.18), rgba(44,83,61,0.06))",
                    borderBottom: "1px solid rgba(44,83,61,0.12)",
                  }}
                >
                  <div className="d-flex align-items-start justify-content-between flex-wrap gap-2">
                  <div>
                      <p className="mb-1 fw-bold">
                      Select your gender.
                      </p>
                    </div>

                     
                  </div>

                   
                </div>

                {/* ✅ smaller body, extra bottom space so browser has room to open dropdown DOWN */}
                <div
                  className="card-body p-3 p-md-4"
                  style={{
                    paddingBottom: 28, // helps dropdown have space below
                  }}
                >
                  
                    {/* ✅ tighter grid */}
                    <div className="row g-3">
                       
                      <div className="col-12 col-md-6">
                       
                      <div className="form-check">
                              <input
                                type="radio"
                                id="male"
                                name="gender"
                                value="Male"
                                className="form-check-input"
                                checked={gender === "Male"}
                                onChange={(e) => setGender(e.target.value)}
                              />
                              <label htmlFor="male" className="form-check-label">
                                Male
                              </label>
                            </div>
                      
                            <div className="form-check mt-2">
                              <input
                                type="radio"
                                id="female"
                                name="gender"
                                value="Female"
                                className="form-check-input"
                                checked={gender === "Female"}
                                onChange={(e) => setGender(e.target.value)}
                              />
                              <label htmlFor="female" className="form-check-label">
                                Female
                              </label>
                            </div>

                      </div> 
                       
                    </div>
                    

                    {/* ✅ tighter actions */}
                    <div className="d-flex justify-content-between mt-3">
                       

                    <button
                        className="btn btn-primary mt-3 w-100"
                        onClick={handleSaveGender}
                        disabled={isSaving || !gender}
                        >
                        {isSaving ? "Saving..." : "Save"}
                        </button>
                    </div>

                   
                </div>
              </div>





 
            </div>
          </div>

          </div>
        </div>
      </div>
    </div>
    );
}

export default SignUpGender;
